/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgSave16(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={17}
      fill='none'
      viewBox='0 0 16 17'
      {...props}
    >
      <g fill='currentColor'>
        <path d='M1.25 1.04A.75.75 0 012 .29h13a.75.75 0 01.75.75v14.566a.75.75 0 01-.75.75H2a.75.75 0 01-.75-.75v-3.362h1.5v2.612h11.5V1.79H2.75v2.612h-1.5V1.04z' />
        <path d='M9.41 9.073H.25v-1.5h9.16L7.421 5.16l1.158-.954 3.393 4.118-3.393 4.118-1.158-.953 1.99-2.415z' />
      </g>
      <defs>
        <clipPath id='save-16_svg__clip0'>
          <path fill='#fff' d='M0 0h16v16.646H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgSave16;
